/* eslint class-methods-use-this: 0 */
// An abstract class for a Tettra Resource

class TettraResourceAbstractSchema {
    constructor() {
        if (this.constructor === TettraResourceAbstractSchema) {
            throw new TypeError('Abstract class "TettraResourceAbstractSchema" cannot be instantiated directly.');
        }
    }

    // Returns (string) uniqueu identifier for object from source
    getId() {
        throw new TypeError('ID Method not defined');
    }

    // Return (string) the resource title
    getTitle() {
        throw new TypeError('Title Method not defined');
    }

    // Return (string) the resource subtitle
    getSubtitle() {
        throw new TypeError('Subtitle Method not defined');
    }

    // Return (string) the resource icon
    getIcon() {
        throw new TypeError('Icon Method not defined');
    }

    getCustomClass() {
        throw new TypeError('Custom Class Method not defined');
    }

    // Return (string) the resource url
    getUrl() {
        throw new TypeError('getUrl Method not defined');
    }

    // Return (bool) if resource is internal (tettra page, question) or external (github, google drive)
    isInternal() {
        throw new TypeError('isInternal Method not defined');
    }
}

export default TettraResourceAbstractSchema;
